import React from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCwIcon, DownloadIcon } from 'lucide-react';
import { OutletDateRange } from '../components/OutletDateRange';
export function Reconciliation() {
  const {
    t
  } = useTranslation('common');
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-7920">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-7921">
        <div data-id="element-7922">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-7923">Reconciliation</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-7924">
            Group and mall-level rollup of per-outlet reconciliation status
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-7925">
          <OutletDateRange data-id="element-7926" />
          <button className="px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors shadow-sm flex items-center gap-2" data-id="element-7927">
            <DownloadIcon size={16} data-id="element-7928" />
            {t('actions.export')}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center" data-id="element-7929">
        <RefreshCwIcon size={48} className="mx-auto text-gray-300 mb-4" data-id="element-7930" />
        <h3 className="text-lg font-medium text-gray-900" data-id="element-7931">
          Reconciliation Rollup
        </h3>
        <p className="text-gray-500 mt-2 max-w-md mx-auto" data-id="element-7932">
          View consolidated reconciliation status (Balanced / Variance /
          Pending) across all malls and outlets.
        </p>
      </div>
    </div>;
}